<template>
	<div class="am-section"
		:class="{
			'is-flipped': flip,
			'is-idle': !init
		}"
	>
		<div class="am-section__container">
			<am-gallery
				class="am-section__gallery"
				:images="images"
				@open="$emit('gallery', images)"
			/>

			<div class="am-section__wrapper">
				<div class="am-section__top">
					<am-text
						class="am-section__title am-section__animate-text"
						type="subtitle"
						v-html="title"
					/>

					<am-text
						class="am-section__text am-section__animate-text text-flow"
						type="body"
						v-html="text"
					/>
					<span v-on:click="openModalText" class="open--modal">Ver mais</span>
					
					<div class="bg--modal"></div>
					<div class="modal--text">
						<am-text
							class="text--modal"
							type="body"
							v-html="text"
						/>
					</div>

				</div>

				<div class="am-section__bottom">
					<svg class="am-section__illustration" v-if="illustration == 'birds'" xmlns="http://www.w3.org/2000/svg" width="106.705" height="85.387" viewBox="0 0 106.705 85.387">
						<g id="Símbolo_5_1" data-name="Símbolo 5 – 1" transform="translate(-246.234 -4637.232)">
							<path id="Caminho_420" data-name="Caminho 420" d="M139.661,1006.948a20.194,20.194,0,0,0-34.236,5.5,20.194,20.194,0,0,0-34.236-5.5" transform="translate(175.81 3672.991)" fill="none" stroke="#d5d3d3" stroke-miterlimit="10" stroke-width="2"/>
							<path id="Caminho_421" data-name="Caminho 421" d="M163.1,1030.559a20.193,20.193,0,0,0-34.236,5.5,20.193,20.193,0,0,0-34.236-5.5" transform="translate(186.609 3683.869)" fill="none" stroke="#d5d3d3" stroke-miterlimit="10" stroke-width="2"/>
							<path id="Caminho_422" data-name="Caminho 422" d="M164.788,983.339a20.194,20.194,0,0,0-34.236,5.5,20.2,20.2,0,0,0-34.237-5.5" transform="translate(187.386 3662.113)" fill="none" stroke="#d5d3d3" stroke-miterlimit="10" stroke-width="2"/>
						</g>
					</svg>

					<svg class="am-section__illustration" v-if="illustration == 'leaf'" xmlns="http://www.w3.org/2000/svg" width="63.925" height="94.807" viewBox="0 0 63.925 94.807">
						<g id="Símbolo_6_1" data-name="Símbolo 6 – 1" transform="translate(-930.531 -6461.854)">
							<line id="Linha_141" data-name="Linha 141" x2="62.768" transform="translate(930.531 6555.661)" fill="none" stroke="#d5d3d3" stroke-miterlimit="10" stroke-width="2"/>
							<path id="Caminho_396" data-name="Caminho 396" d="M127.824,153.89A24.167,24.167,0,0,0,107.3,133.364S107.819,150.175,127.824,153.89Z" transform="translate(827.598 6357.626)" fill="none" stroke="#d5d3d3" stroke-miterlimit="10" stroke-width="2"/>
							<path id="Caminho_397" data-name="Caminho 397" d="M139.247,176.465A31.852,31.852,0,0,0,166.3,149.408S144.145,150.1,139.247,176.465Z" transform="translate(826.995 6357.324)" fill="none" stroke="#d5d3d3" stroke-miterlimit="10" stroke-width="2"/>
							<path id="Caminho_398" data-name="Caminho 398" d="M134.843,140.216" transform="translate(827.078 6357.497)" fill="none" stroke="#d5d3d3" stroke-miterlimit="10" stroke-width="2"/>
							<path id="Caminho_399" data-name="Caminho 399" d="M134.843,197.5v-53.33a60.976,60.976,0,0,1,1.17-12.195c2.04-10,7.433-22.724,27.3-27.068,0,0,2.909,26.491-24.366,34.644" transform="translate(827.078 6358.163)" fill="none" stroke="#d5d3d3" stroke-miterlimit="10" stroke-width="2"/>
						</g>
					</svg>

					<svg class="am-section__illustration" v-if="illustration == 'locker'" xmlns="http://www.w3.org/2000/svg" width="66.22" height="91.531" viewBox="0 0 66.22 91.531">
						<g id="Símbolo_4_1" data-name="Símbolo 4 – 1" transform="translate(-929 -4863)">
							<g id="Agrupar_527" data-name="Agrupar 527" transform="translate(930 4864)">
								<rect id="Retângulo_301" data-name="Retângulo 301" width="64.22" height="49.849" transform="translate(0 39.682)" fill="rgba(0,0,0,0)" stroke="#d5d3d3" stroke-width="2"/>
								<rect id="Retângulo_302" data-name="Retângulo 302" width="64.22" height="49.849" transform="translate(0 39.682)" fill="rgba(0,0,0,0)" stroke="#d5d3d3" stroke-width="2"/>
								<path id="Caminho_418" data-name="Caminho 418" d="M760.727,879.348V860.662a21,21,0,0,1,41.993,0v19.121" transform="translate(-749.614 -839.667)" fill="rgba(0,0,0,0)" stroke="#d5d3d3" stroke-width="2"/>
								<rect id="Retângulo_303" data-name="Retângulo 303" width="7.646" height="12.849" rx="3.823" transform="translate(28.287 57.682)" fill="rgba(0,0,0,0)" stroke="#d5d3d3" stroke-width="2"/>
							</g>
						</g>
					</svg>

					<svg class="am-section__illustration" v-if="illustration == 'star'" xmlns="http://www.w3.org/2000/svg" width="88.096" height="88.096" viewBox="0 0 88.096 88.096">
						<g id="Símbolo_10_1" data-name="Símbolo 10 – 1" transform="translate(-276 -6233)">
							<g id="Agrupar_574" data-name="Agrupar 574" transform="translate(277 6234)">
								<path id="Caminho_431" data-name="Caminho 431" d="M737.667,722.865V701.341h21.524" transform="translate(-737.667 -701.341)" fill="none" stroke="#d8d6d6" stroke-miterlimit="10" stroke-width="2"/>
								<path id="Caminho_432" data-name="Caminho 432" d="M759.191,776.865H737.667V755.341" transform="translate(-737.667 -690.769)" fill="none" stroke="#d8d6d6" stroke-miterlimit="10" stroke-width="2"/>
								<path id="Caminho_433" data-name="Caminho 433" d="M813.191,755.341v21.524H791.667" transform="translate(-727.095 -690.769)" fill="none" stroke="#d8d6d6" stroke-miterlimit="10" stroke-width="2"/>
								<path id="Caminho_434" data-name="Caminho 434" d="M791.667,701.341h21.524v21.524" transform="translate(-727.095 -701.341)" fill="none" stroke="#d8d6d6" stroke-miterlimit="10" stroke-width="2"/>
							</g>
							<path id="Caminho_435" data-name="Caminho 435" d="M777.391,755.124l-14.057,7.39,2.685-15.653-11.373-11.086,15.716-2.284,7.029-14.241,7.029,14.241,15.717,2.284-11.373,11.086,2.685,15.653Z" transform="translate(-457.343 5536.165)" fill="none" stroke="#d8d6d6" stroke-miterlimit="10" stroke-width="2"/>
						</g>
					</svg>

					<svg class="am-section__illustration" v-if="illustration == 'trees'" xmlns="http://www.w3.org/2000/svg" width="141.527" height="74.773" viewBox="0 0 141.527 74.773">
						<g id="Symbol_2" data-name="Symbol 2" transform="translate(-249 -3033)">
							<g id="Agrupar_515" data-name="Agrupar 515" transform="translate(263.265 3034)">
								<path id="Caminho_403" data-name="Caminho 403" d="M1207.04,151.386a26.684,26.684,0,0,0,36.831-5.306,17.216,17.216,0,1,0,0-32.57,26.686,26.686,0,0,0-47.779,14.654q-.049.809-.049,1.631" transform="translate(-1172.448 -103.106)" fill="none" stroke="#d5d3d3" stroke-miterlimit="10" stroke-width="2"/>
								<path id="Caminho_481" data-name="Caminho 481" d="M0,61.357V0" transform="translate(49.045 11.415)" fill="none" stroke="#d5d3d3" stroke-width="2"/>
								<path id="Caminho_482" data-name="Caminho 482" d="M0,39.137V0" transform="translate(77.96 22.819)" fill="none" stroke="#d5d3d3" stroke-width="2"/>
								<path id="Caminho_483" data-name="Caminho 483" d="M0,17.038,17.038,0" transform="translate(49.045 25.056)" fill="none" stroke="#d5d3d3" stroke-width="2"/>
								<path id="Caminho_484" data-name="Caminho 484" d="M11.8,11.8,0,0" transform="translate(37.248 16.304)" fill="none" stroke="#d5d3d3" stroke-width="2"/>
								<path id="Caminho_485" data-name="Caminho 485" d="M0,7.653,7.653,0" transform="translate(77.96 28.53)" fill="none" stroke="#d5d3d3" stroke-width="2"/>
								<path id="Caminho_486" data-name="Caminho 486" d="M0,6.085,6.085,0" transform="translate(23.595 44.861)" fill="none" stroke="#d5d3d3" stroke-width="2"/>
								<path id="Caminho_487" data-name="Caminho 487" d="M6.085,6.085,0,0" transform="translate(17.509 38.007)" fill="none" stroke="#d5d3d3" stroke-width="2"/>
								<path id="Caminho_488" data-name="Caminho 488" d="M11.276,0A11.276,11.276,0,0,1,22.551,11.276v8.44A11.276,11.276,0,0,1,0,19.716v-8.44A11.276,11.276,0,0,1,11.276,0Z" transform="translate(12.319 26.1)" fill="none" stroke="#d5d3d3" stroke-width="2"/>
								<path id="Caminho_404" data-name="Caminho 404" d="M1245.731,177.062a13.3,13.3,0,1,1,26.6,0" transform="translate(-1173.418 -104.289)" fill="none" stroke="#d5d3d3" stroke-miterlimit="10" stroke-width="2"/>
								<path id="Caminho_405" data-name="Caminho 405" d="M1171.979,177.062a13.3,13.3,0,1,1,26.6,0" transform="translate(-1171.979 -104.289)" fill="none" stroke="#d5d3d3" stroke-miterlimit="10" stroke-width="2"/>
								<path id="Caminho_406" data-name="Caminho 406" d="M1286.759,176.8V161.864a11.666,11.666,0,1,0-23.331,0v2.265" transform="translate(-1173.763 -104.025)" fill="none" stroke="#d5d3d3" stroke-miterlimit="10" stroke-width="2"/>
								<path id="Caminho_489" data-name="Caminho 489" d="M0,0V30.764" transform="translate(23.595 33.575)" fill="none" stroke="#d5d3d3" stroke-width="2"/>
							</g>
							<line id="Linha_150" data-name="Linha 150" x2="141.527" transform="translate(249 3106.773)" fill="none" stroke="#d5d3d3" stroke-miterlimit="10" stroke-width="2"/>
						</g>
					</svg>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import AMText from '@/components/atoms/AMText'
import AMGallery from '@/components/molecules/AMGallery'
import { mapGetters } from 'vuex'
import { TweenMax, Power2 } from 'gsap/TweenMax'
import anime from 'animejs'
import 'jquery'
window.jQuery = $
import $ from 'jquery'

export default {
	components: {
		'am-text': AMText,
		'am-gallery': AMGallery
	},

	props: {
		title: {
			type: String,
			default: 'Lorem ipsum sit amet<br /> muspim emrol its'
		},
		text: {
			type: String,
			default: 'Consectetur vel qui fugiat cum iste. Quisquam incidunt provident pariatur delectus illo fuga? Explicabo eum quam explicabo totam molestias, harum. Quos quia minus ipsa nobis officiis? Minus ipsum velit dignissimos.'
		},
		images: {
			type: Array,
			default: undefined
		},
		illustration: {
			type: String,
			default: 'birds' // birds | locker | star | leaf | trees
		},
		flip: {
			type: Boolean,
			default: false
		},
		init: {
			type: Boolean,
			default: true
		}
	},

	computed: {
		...mapGetters({
			viewport: 'viewport/getCurrent'
		})
	},

	mounted() {
		if (this.init)
			this.start()
	},

	watch: {
		init(value) {
			if (value)
				this.start()
		}
	},

	methods: {

		openModalText() {
			$('body').on('click', '.open--modal', function(event){
				event.preventDefault();
			    $('.bg--modal').fadeIn();
			    $('.modal--text').fadeIn();
			});
			$('body').on('click', '.bg--modal', function(event){
				event.preventDefault();
			    $('.bg--modal').fadeOut();
			    $('.modal--text').fadeOut();
			});
		},

		start() {
			// Text
			TweenMax.staggerFrom(this.$el.querySelectorAll('.am-section__animate-text'), 2, {
				y: "+=30",
				opacity: 0,
				ease: Power2.easeOut
			}, .5)

			// Gallery
			TweenMax.staggerFrom(this.$el.querySelectorAll('.am-section__gallery'), 2, {
				x: this.viewport == 'smartphone' ? '0%' : this.flip ? '-30%' : '30%',
				y: this.viewport == 'smartphone' ? '-30%' : 0,
				opacity: 0,
				ease: Power2.easeOut
			})

			// Bottom
			TweenMax.staggerFrom(this.$el.querySelectorAll('.am-section__bottom'), 2, {
				y: "+=200",
				opacity: 0,
				ease: Power2.easeOut,
				complete: () => {
					// Illustration
					anime({
						targets: this.$el.querySelectorAll('.am-section__illustration path'),
						strokeDashoffset: [anime.setDashoffset, 0],
						opacity: 1,
						easing: 'easeInOutSine',
						duration: 1000,
						delay: function(el, i) { return (i * 100) + 1000 },
					})
				}
			})
		},
	}
}
</script>

<style lang="scss">
.am-section{
	background: white;
	position: relative;
	z-index: 10;
	overflow: hidden;
	transition: .3s $easeInOutQuad;
	@include grid-container;
	&__container{
		height: 100%;
		display: flex;
		flex-flow: column;
		// @include outer-container;
	}
	&__wrapper{
		padding: 24px 0;
		flex: 2;
		flex-shrink: 0;
		display: flex;
		flex-flow: column;
		justify-content: space-between;
		@include grid-column(6);
	}
	&__gallery{
		flex: 1;
		&:after{
			padding-top: 0;
		}
	}
	&__top{
		flex: 1;
		display: flex;
		flex-flow: column;
		padding: 32px 0;
	}
	&__title{
		margin-bottom: 16px;
		text-transform: uppercase;
		span {
			color: #D5D3D3;
			display: block;
		}
	}
	&__text{
	}
	&__bottom{
		display: flex;
		align-items: center;
		justify-content: center;
		flex-shrink: 0;
		box-sizing: border-box;
		z-index: -1;
	}
	&__illustration{
		// width: 80px;
	}

	&.is-idle{
		opacity: 0;
		.am-section{
			&__animate-text,
			&__illustration{
			}
		}
	}

	@include grid-media($desktop-grid) {
		.am-section{
			&__wrapper{
				padding: 0;
				width: 50%;
				margin: 0;
				display: flex;
				align-items: center;
			}
			&__top{
				height: 300px;
				width: 400px;
				justify-content: center;
			}
			&__title{
				margin-bottom: 40px;
			}
			&__bottom{
				height: 100px;
				padding: 26px 0;
				&:before{
					content: "";
					position: absolute;
					height: 150px;
					left: -999px;
					right: -999px;
					background: #F8F8F8;
					z-index: -1;
				}
			}
			&__gallery{
				position: absolute;
				top: 0;
				right: 0;
				bottom: 0;
				left: 50%;
			}
		}
		&__illustration{
			width: auto;
		}

		&.is-flipped{
			.am-section{
				&__wrapper{
					@include grid-push(6);
				}
				&__gallery{
					right: 50%;
					left: 0;
				}
			}
		}

	}

	.text-flow{
		max-height: 400px;
		overflow: hidden;
		@media (max-width: 1410px) {
			max-height: 228px;
		}
	}
	.open--modal{
		display: inline-block;
	    background: #99887F;
	    color: #fff;
	    font-family: Khand;
	    max-width: max-content;
	    padding: 10px 50px;
	    border-radius: 50px;
	    margin-top: 20px;
	    cursor: pointer;
	    font-size: 16px;
	    transition: 0.4s cubic-bezier(0.455, 0.03, 0.515, 0.955);
	    &:hover{
	    	opacity: 0.7
	    }
	}
	.bg--modal{
		display: none;
		position: fixed;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
		background-color: rgba(255,255,255,0.95);
		z-index: 10;
		cursor: zoom-out;
	}
	.modal--text{
		display: none;
		position: absolute;
		width: 100%;
		max-width: 600px;
		padding: 15px;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		z-index: 11;
		.am-text{
			position: relative;
			z-index: 2;
		}
	}
}
</style>
